import { EmploymentStatus } from 'hooks/webapi/useClient';
import { fetchData } from 'utils';

export default async function getClient(): Promise<Client> {
  return await fetchData('/client');
}

export type Client = {
  firstName: string;
  lastName: string;
  declaredAddress: {
    fullAddress: string;
    location1: string;
    location2: string;
    postalCode: string;
  };
  hasAttachments: boolean;
  hasOcrSession: boolean;
  has0penLoanApplication: boolean;
  id: number;
  employer: {
    address?: string;
    name?: string;
    employmentStatus?: EmploymentStatus;
    employmentDetail?: string;
  };
  number: string;
  identified: boolean;
  status:
    | 'UNKNOWN'
    | 'REGISTERED'
    | 'IDENTIFIED'
    | 'DELETED'
    | 'VALIDATED'
    | 'ACTIVE'
    | 'NOT_IDENTIFIED'
    | 'BANK_ID';
  actualAddress: {
    fullAddress: string;
    location2: string;
    postalCode: string;
  };
  mobilePhoneVerified: boolean;
  fullName: string;
  bankAccount?: string;
  personalId: string;
  identityDocumentId: string;
  dateOfBirth: string;
  age: number;
  identifiedBy:
    | 'BANK'
    | 'BANK_ID'
    | 'MANUAL'
    | 'ID_SERVICE'
    | 'BROKER'
    | 'EMAIL'
    | 'IMMEDIATE_TRANSFER'
    | 'FINTONIC'
    | 'PRESTALO'
    | 'NOT_IDENTIFIED';
  registeredBy:
    | 'WEB'
    | 'OFFLINE'
    | 'BROKER'
    | 'CALL_CENTER'
    | 'LEAD_GENERATOR'
    | 'WEB_OTHER_PRODUCT';
  nationality: string;
};
